var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5833 4.41667H29.4167V0.25H8.58333V4.41667H4.41667C2.125 4.41667 0.25 6.29167 0.25 8.58333V10.6667C0.25 15.9792 4.25 20.3125 9.39583 20.9583C10.7083 24.0833 13.5208 26.4375 16.9167 27.125V33.5833H8.58333V37.75H29.4167V33.5833H21.0833V27.125C24.4792 26.4375 27.2917 24.0833 28.6042 20.9583C33.75 20.3125 37.75 15.9792 37.75 10.6667V8.58333C37.75 6.29167 35.875 4.41667 33.5833 4.41667ZM4.41667 10.6667V8.58333H8.58333V16.5417C6.16667 15.6667 4.41667 13.375 4.41667 10.6667ZM33.5833 10.6667C33.5833 13.375 31.8333 15.6667 29.4167 16.5417V8.58333H33.5833V10.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.b37b8e2fdaddb9312180c1020b5f3928.svg";
export { ForwardRef as ReactComponent };